export const SYSTEM_SETTING_STORE = 'SYSTEM_SETTING_STORE';
export const SYSTEM_SETTING_STORE_SUCCESS = 'SYSTEM_SETTING_STORE_SUCCESS';
export const SYSTEM_SETTING_SEARCH = 'SYSTEM_SETTING_SEARCH';
